import React, { useState } from 'react';
import Space from './Space';
import Row from './Row';

const Tab = ({ label, onClick, isActive, invert }) => (
  <div
    className={(isActive ? "ui-tab-active" : "ui-tab") + (invert ? " invert" : "")}
    onClick={onClick}
  >
    <nobr>{label}</nobr>
  </div>
);

const TabContent = ({ content, height = 100, content_class = "ui-tabs-content", invert }) => (
  <div
    style={{ height: height + "px" }}
    className={content_class + (invert ? " invert" : "")}
  >
    {content}
  </div>
);

const Tabs = (props) => {
  const {
    tabData = [],
    style = {},
    height = 100,
    content_class = "ui-tabs-content",
    border = true,
    indent = false,
    invert = false,
    br = <></>,
    selected = "",
    show_content = true,
    onChange = () => { },
  } = props;

  const handleTabClick = (id) => {
    onChange(id);
  };

  const tabRow = (
    <div
      style={{
        borderBottom: !invert && border ? "1px solid var(--border-secondary)" : "none",
        borderTop: invert && border ? "1px solid var(--border-secondary)" : "none",
      }}
    >
      <Row style={{ marginLeft: indent ? "10px" : "0px" }} gap={2}>
        {tabData.map((tab) => (
          <Row.Item key={tab.id} flexGrow={0}>
            <Tab
              label={tab.label}
              isActive={tab.id === selected}
              onClick={() => handleTabClick(tab.id)}
              invert={invert}
            />
          </Row.Item>
        ))}
      </Row>
    </div>
  );


  const contentArea = show_content && (
    <div
      style={{
        height: typeof height === "number" ? `${height}px` : height,
        minHeight: 0,
        overflow: "hidden"
      }}
    >
      {tabData.map((tab) => {
        const isActive = tab.id === selected;

        return (
          <div
            key={tab.id}
            className={content_class + (invert ? " invert" : "")}
            style={{
              display: isActive ? "block" : "none",
              height: "100%",
              minHeight: 0,
              overflow: "hidden",
              margin: 0
            }}
          >
            <div
              style={{
                height: "100%",
                minHeight: 0,
                padding: 0
              }}
            >
              {tab.content}
            </div>
          </div>
        );
      })}
    </div>
  );

  return (
    <div style={{ ...style }}>
      {invert ? (
        <>
          {contentArea}
          {br}
          {tabRow}
        </>
      ) : (
        <>
          {tabRow}
           {br}
          {contentArea}
        </>
      )}
    </div>
  );
};

export default Tabs;
